import { signOut } from '@/core';
import { ActionType, Routes } from '@/constants';
import router from '@/router';
import store from '@/store';
import { getRememberMe, setRememberMe } from '.';

const getSession = () => {
  return localStorage.getItem('inactiveSession') || '';
}

const setSession = (value: string) => {
  localStorage.setItem('inactiveSession', value);
}

const verifyUserInactivity = () => {
  return new Promise((resolve) => {
    const millisecInSec = 1000;
    const secInMinute = 60;
    const currentTimestamp = Date.now();
    const lastTimestamp = getSession();
    const inactiveThresholdMinutes = process.env.VUE_APP_SESSION_TIMEOUT;
    if (lastTimestamp && !!inactiveThresholdMinutes) {
      const diff = (currentTimestamp - parseInt(lastTimestamp)) / millisecInSec;
      if (diff > (parseInt(inactiveThresholdMinutes) * secInMinute)) {
        const rememberMe = getRememberMe();
        signOut().then((data) => {
          store.dispatch(ActionType.UPDATE_SELECTED_JOB, rememberMe);
          !!rememberMe && setRememberMe(rememberMe);
          router.push({ name: Routes.SIGNIN });
          resolve(false);
        });
      } else {
        setSession(currentTimestamp.toString());
        resolve(true);
      }
    } else {
      setSession(currentTimestamp.toString());
      resolve(true);
    }
  })
};

export { verifyUserInactivity };
